<template>
  <div>
    <DeletePublishingScheduleDialog
      v-if="isOpen"
      :publishingSchedule="publishingSchedule"
      :isOpen="isOpen"
      @close="closeDialog"
    />
    <DotMenu :items="menuItems()" @select="openActionDialog" />
  </div>
</template>

<script>
import { DotMenu } from "@/components/common/Menu";
import DeletePublishingScheduleDialog from "@/views/settings/components/publishing-schedule-templates/components/dialogs/DeletePublishingScheduleDialog";

export default {
  props: {
    publishingSchedule: Object
  },
  components: {
    DotMenu,
    DeletePublishingScheduleDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    menuItems() {
      return [
        {
          title: `Delete`,
          action: () => {
            this.openDialog();
          }
        }
      ];
    },
    openActionDialog(action) {
      action();
    },
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
